import {
  DialogType,
  IColumn,
  ICommandBarItemProps,
  Icon,
  TooltipHost,
} from "@fluentui/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HeadingBar } from "../../../components/Generic/HeadingBar";
import { TableBase } from "../../../components/Table/TableBase";
import { IconHelper } from "../../../utils/Helper/iconHelper";
import ThemeBase from "../../../utils/Theme/themeBase";
import { useBoolean } from "@fluentui/react-hooks";
import { DialogBase } from "../../../components/Dialog/DialogBase";
import { ConfigHelper } from "../../../utils/Helper/configHelper";
import { useMakeStyle } from "../../../functions/BaseStyle";
import { useListaLugaresMovilizacionHorarios } from "./useListaLugaresMovilizacionHorarios";
import { PanelCrearLugarMovilizacionHorario } from "./Crear/PanelCrearLugarMovilizacionHorario";
import { IListarLugarMovilizacionHorarioDto } from "../../../interfaces/ILugarMovilizacionHorario";
import { _formatTime24 } from "../../../utils/Helper/datetimeHelper";
import { SearchBox } from "@fluentui/react-components";
import { TableComponent } from "../../../components/Table/TableComponent";
import { IButtonGroup } from "../../../interfaces/base/ITable";

export const ListaLugaresMovilizacionHorarios = () => {
  const navigate = useNavigate();

  const [dataEdit, setDataEdit] = useState<IListarLugarMovilizacionHorarioDto>(
    null!
  );

  const [
    isOpenEliminar,
    { setTrue: openPanelEliminar, setFalse: closePanelEliminar },
  ] = useBoolean(false);
  const style = useMakeStyle();

  /* Panel Form Registrar / Editar */
  const [isOpenPanel, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const {
    items,
    filter,
    setFilter,
    loadingTabla,
    pagination,
    handleResetUpdate,
    deleteEliminarLugarMovilizacionHorario,
    loadingDelete,
    status,
    mensaje,
  } = useListaLugaresMovilizacionHorarios(
    dataEdit?.lugarMovilizacionHorarioId,
    closePanelEliminar
  );

  const _columns: IColumn[] = [
    {
      key: "numeracion",
      name: "N°",
      fieldName: "numeracion",
      minWidth: 30,
      maxWidth: 50,
      onRender: (_, index) => <>{(index ?? 0) + 1}</>,
    },
    {
      key: "nombreLugarMovilizacion",
      name: "Lugar",
      fieldName: "nombreLugarMovilizacion",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "horarioEmbarque",
      name: "Horario Embarque",
      /* fieldName: "horarioEmbarque", */
      minWidth: 100,
      maxWidth: 100,
      isResizable: false,
      onRender: (item: IListarLugarMovilizacionHorarioDto) => (
        <>{item.horarioEmbarque ? _formatTime24(item.horarioEmbarque) : "-"}</>
      ),
    },
    {
      key: "horarioSalida",
      name: "Horario Salida",
      /* fieldName: "horarioSalida", */
      minWidth: 100,
      maxWidth: 100,
      isResizable: false,
      onRender: (item: IListarLugarMovilizacionHorarioDto) => (
        <>{item.horarioSalida ? _formatTime24(item.horarioSalida) : "-"}</>
      ),
    },
    {
      key: "comentario",
      name: "Comentario",
      fieldName: "comentario",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "nombreGuardia",
      name: "Guardia",
      fieldName: "nombreGuardia",
      minWidth: 100,
      maxWidth: 100,
      isResizable: false,
    },
    {
      key: "turno",
      name: "Turno",
      fieldName: "turno",
      minWidth: 100,
      maxWidth: 100,
      isResizable: false,
    },
    {
      key: "regimen",
      name: "Régimen",
      fieldName: "regimen",
      minWidth: 100,
      maxWidth: 100,
      isResizable: false,
    },
    {
      key: "tipoProgramacion",
      name: "Tipo Programación",
      fieldName: "tipoProgramacion",
      minWidth: 100,
      maxWidth: 100,
      isResizable: false,
    },
    {
      key: "nombreActividad",
      name: "Actividad",
      fieldName: "nombreActividad",
      minWidth: 100,
      maxWidth: 100,
      isResizable: false,
    },
    {
      key: "usuarioRegistra",
      name: "Usuario Registra",
      fieldName: "usuarioRegistra",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      minWidth: 80,
      maxWidth: 100,
      fieldName: "opciones",
      isResizable: false,
      onRender: (item: any) => renderOpciones(item),
    },
  ];

  function renderOpciones(item: IListarLugarMovilizacionHorarioDto) {
    return (
      <div
        style={{
          display: "flex",
          gap: "10px",
        }}
      >
        <TooltipHost content={`Editar`}>
          <Icon
            iconName="Edit"
            style={{
              cursor: "pointer",
            }}
            className={ThemeBase.classes.iconFont}
            onClick={() => {
              setDataEdit(item);
              openPanel();
            }}
          />
        </TooltipHost>
        <TooltipHost content={`Elminar`}>
          <Icon
            iconName="Delete"
            style={{ cursor: "pointer" }}
            className={ThemeBase.classes.iconFont}
            onClick={() => {
              setDataEdit(item);
              openPanelEliminar();
            }}
          />
        </TooltipHost>
      </div>
    );
  }

  const _leftBar = () => {
    const _items: IButtonGroup[] = [
      {
        text: "Atrás",
        onClick: () => navigate(`${ConfigHelper.urlBase()}/configuraciones`),
      },
      {
        text: "Nuevo",
        onClick: () => {
          openPanel();
          setDataEdit(null!);
        },
      },
      {
        text: "Actualizar",
        onClick: handleResetUpdate,
      },
    ];
    return _items;
  };

  const rightBar = () => {
    const _items: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_FILTER,
        onClick: () => {},
        onRender: () => (
          <SearchBox
            value={filter.search ?? ""}
            style={{ width: "200px", height: "32px", marginBottom: "2px" }}
            placeholder={"Buscar por lugar de movilización"}
            onChange={(searchEvent, inputChangeEvent) =>
              setFilter({ ...filter, search: inputChangeEvent.value })
            }
          />
        ),
      },
    ];
    return _items;
  };

  return (
    <div className={style.body}>
      <HeadingBar
        title="Horarios por lugar de movilización"
        subTitle="Gestión de horarios por lugar de movilización"
        searchShow={false}
      ></HeadingBar>

      <TableComponent
        data={items}
        leftButtons={_leftBar()}
        column={_columns}
        isLoading={loadingTabla}
        paginacion={pagination}
        isSearch
        onChangeSearch={(_, newValue?: string | undefined) => {
          setFilter({ ...filter, skip: 0, search: newValue });
        }}
        searchValue={filter.search ?? ""}
      ></TableComponent>

      {isOpenPanel && (
        <PanelCrearLugarMovilizacionHorario
          isOpen={isOpenPanel}
          onDismiss={dismissPanel}
          reload={handleResetUpdate}
          dataEdit={dataEdit}
          setDataEdit={setDataEdit}
        />
      )}

      <DialogBase
        isHidden={!isOpenEliminar}
        title={"Eliminar horario por lugar de movilización"}
        subTitle={
          status === 200 || status === 500
            ? mensaje
            : "El horario por lugar de movilización será eliminado permanentemente"
        }
        tipo={DialogType.normal}
        toggleHidden={() => {
          closePanelEliminar();
        }}
        dependency={[]}
        confirm={deleteEliminarLugarMovilizacionHorario}
        titleLoading={"Eliminando horario por lugar de movilización"}
        subTitleLoading={"Por favor espere..."}
        isDisableConfirm={loadingDelete}
      ></DialogBase>
    </div>
  );
};
